<app-navbar></app-navbar>

<!-- Content -->
<div class="container-fluid" id="top">
  <div class="row py-lg-5">
    <div class="col-sm-6 offset-sm-3 project-content">
      <mdb-card>
        <!-- Project's informations -->
        <mdb-card-title>
          <!-- Project Title -->
          <h2>CREATION D'UN COURT-METRAGE AVEC OPENGL ET C++</h2>
          <!-- Project date + duration -->
          <h4><b>Fin :</b> Novembre 2020</h4>
          <h4><b>Durée :</b> 3 mois</h4>
        </mdb-card-title>
        <!-- Project image -->
        <mdb-card-img class="project-picture" src="assets/IG_proj.jpg"></mdb-card-img>
        <!-- About the project -->
        <mdb-card-body>
          <!-- Technologies used -->
          <div class="row technos">
            <div class="col-sm-6">
              <div class="row">
                <h4><b>Technologies : </b></h4>
                <img class="dot" src="assets/skills/opengl.png"/>
                <img class="dot" src="assets/skills/c++.png"/>
                <img class="dot" src="assets/skills/gitlab.png"/>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <h4><b>Tags : </b></h4>
                <p> OpenGL, C++, Animation/Rendu 3D, Gitlab</p>
              </div>
            </div>
          </div>
          <!-- Contenu du projet -->
          <div class="row description">
            <!-- Description of the project -->
            <div class="col-sm-6">
              <h4><b>Description :</b></h4>
              <p>
                Dans le cadre du cours d'<b>Informatique graphique</b> de 4e année, j'ai pu découvrir les bases d'OpenGL au
                travers d'un ensemble de TP (pipeline, shaders, animation, illumination, textures, ...). L'objectif fut
                ensuite à partir de la base de code fournie (utilisée lors des TP), de réaliser une <b>animation en 3D</b> d'un
                vaisseau spatial avec <b>OpenGL</b> et le langage <b>C++</b>.
              </p>
            </div>
            <!-- Apports du projet -->
            <div class="col-sm-6">
              <h4><b>Bilan :</b></h4>
              <p>
                Grâce à ce projet, j'ai pu utiliser les connaissances que j'ai acquises lors des cours
                de C++. J'ai également pu découvrir l'informatique graphique et le monde du <b>rendu</b> et de
                l'<b>animation 3D</b>. <br>
                Suite à ce projet, j'ai décidé de continuer à approfondir mes connaissances en OpenGL, mais également
                de découvrir les autres API. Mon objectif étant d'acquérir les connaissances nécessaires afin de débuter
                dans un poste de <b>Programmeur 3D</b>.
              </p>
            </div>
          </div>
        </mdb-card-body>
      </mdb-card>
      <h4 class="video-title"><b>Résultat :</b></h4>
      <div class="row">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/c7O_dv-8rrw" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                class="video">
        </iframe>
      </div>
    </div>
  </div>
</div>

<app-projects></app-projects>

